import React from "react";
import "./RightElements.css";

const MotivationalMission = () => (
  <div className="rightmenu-card motivational-mission-card">
    <div className="section">
      <span className="get-pro-title">Progreseaza în fiecare zi</span>
      <div className="section-desc" style={{ marginTop: 12 }}>
        Completeaza obiectivele zilnice si apropie-te de urmatorul nivel profesional.
      </div>
    </div>
  </div>
);

export default MotivationalMission;
